import React from 'react';
import { Component } from '../../../dispatcher/modules';
import Container from '../container/Container';
import _ from 'lodash';
import classnames from 'classnames';
import { PUZZLE_INFO_BAR_PROPS } from './Types';

export default class PuzzleInfoBar extends Component<PUZZLE_INFO_BAR_PROPS> {
  static defaultProps = {
    vBox: true,
    variant: 'info'
  }

  render() {
    const {
      children,
      variant,
      className
    } = this.props;

    const infoBarClassName = classnames(
      `tp-info-bar ${className}`,
      {
        'tp-with-grey-bg': variant === 'neutral',
        'tp-with-red-bg': variant === 'negative',
        'tp-with-green-bg': variant === 'positive',
        'tp-with-yellow-bg': variant === 'warning'
      }
    );
    const puzzlePanelRowProps = _.omit(this.props, ['children']);

    return (
      <Container
        {...puzzlePanelRowProps}
        className={infoBarClassName}
      >
        {children}
      </Container>
    );
  }
}
